import { selectOperatingDateForTask } from '../Selectors'
import { Task } from '../types'

export const generateEquipmentInfoKey = ({
  trainNumber,
  operatingDate,
  fromStation,
  toStation,
}: {
  trainNumber: string
  operatingDate?: string
  fromStation: string
  toStation: string
}) => `${trainNumber}+${operatingDate}+${fromStation}+${toStation}`

export const generateEquipmnentInfoKeyFromTask = (task: Task) =>
  generateEquipmentInfoKey({
    trainNumber: task.trainNumberNumeric || '',
    operatingDate: selectOperatingDateForTask(task),
    fromStation: task.fromStation,
    toStation: task.toStation,
  })
